// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23AEo","colMin":"styles_colMin__YNMF5"};